import {
    Badge,
    BlockStack,
    Button,
    Card,
    InlineStack,
    Text,
} from '@shopify/polaris';
import React from 'react';
import { DI, DIProps } from '../../../../Core/index';
import { Carousel } from 'antd';
import heroFeature1 from '../../../../Asests/Images/herofeature1.png';
import heroFeature2 from '../../../../Asests/Images/herofeature2.jpg';
import marginProImg from '../../../../Asests/Images/margin-pro.jpg';

import { t } from 'i18next';


const HeroSection = (props: DIProps) => {
    return (
        <Carousel
            autoplay
            autoplaySpeed={3000}
            slidesToShow={1}
            dots={true}
            arrows={false}
            draggable
            infinite
            pauseOnHover
            className='custom-hero-section__container'
            responsive={[
                {
                    breakpoint: 991,
                    settings: {
                        dots: false,
                    },
                },
                {
                    breakpoint: 767,
                    settings: {
                        dots: true,
                    },
                },
            ]}
        >
            <Card roundedAbove="sm" background='bg-surface-warning' padding={"300"}>
                <BlockStack gap="400">
                    <img
                        alt="Margin Pro Banner"
                        width="100%"
                        height="100%"
                        src={marginProImg}
                        className='custom-hero-section__image'
                    />
                    <BlockStack gap="300" inlineAlign="start">
                        <Badge tone="attention-strong">Margin Pro</Badge>
                        <BlockStack gap="200">
                            <Text as="h4" variant="headingMd">
                                Maximize Margins. Minimize Losses
                            </Text>
                            <BlockStack gap={"050"}>
                                <Text as="span" variant="bodyMd" tone='subdued' fontWeight='regular'>
                                    Cut shipping costs, recover lost revenue, and reduce fees with Margin Pro, the new profit protection platform from Threecolts
                                </Text>
                                <Text as='span' variant='bodyMd' fontWeight='medium' tone='subdued'>Lower shipping costs at zero cost to you.</Text>
                            </BlockStack>
                        </BlockStack>
                    </BlockStack>
                    <div style={{height:"unset"}}>
                        <InlineStack align="start">
                            <Button
                                onClick={() => window.open("https://calendly.com/d/cnbs-j8n-bpp/cedcommerce-margin-pro-discovery?utm_source=Calendly&utm_medium=Promotion&utm_campaign=CedCommerce+%2B+Margin+Pro+Discovery", "__blank")}
                            >
                                Know More
                            </Button>
                        </InlineStack>
                    </div>
                </BlockStack>
            </Card>
            <Card roundedAbove="sm" background='bg-surface-warning' padding={"300"}>
                <BlockStack gap="400">
                    <img
                        alt="Multilingual Banner"
                        width="100%"
                        height="100%"
                        src={heroFeature1}
                        className='custom-hero-section__image'
                    />
                    <BlockStack gap="300" inlineAlign="start">
                        <Badge tone="attention-strong">{t("New Feature")}</Badge>
                        <BlockStack gap="200">
                            <Text as="h4" variant="headingMd">
                                {t("Global Selling Made Easier with Multilingual Support!")}
                            </Text>
                            <Text as="span" variant="bodyMd" tone='subdued' fontWeight='regular'>
                                {t("Our platform now supports")}
                                <Text as='span' fontWeight='semibold' variant='bodyMd' tone='subdued'> {t("Hindi, Dutch, French, and Spanish")}</Text>, {t("helping you navigate your business with ease and confidence in the language of your choice.")}
                            </Text>
                        </BlockStack>
                    </BlockStack>
                    <InlineStack align="start">
                        <Button
                            onClick={() => props.history("../config/accounts")}
                        >
                            {t("Change language")}
                        </Button>
                    </InlineStack>
                </BlockStack>
            </Card>
            <Card roundedAbove="sm" background='bg-surface-warning' padding={"300"}>
                <BlockStack gap="400">
                    <img
                        alt="2000 variant Banner"
                        width="100%"
                        height="100%"
                        src={heroFeature2}
                        className='custom-hero-section__image'
                    />
                    <BlockStack gap="300" inlineAlign="start">
                        <Badge tone="attention-strong">{t("New Feature")}</Badge>
                        <BlockStack gap="200">
                            <Text as="h4" variant="headingMd">
                                {t("Expand Your Product Options with 2000 Variants!")}
                            </Text>
                            <Text as="span" variant="bodyMd" tone='subdued' fontWeight='regular'>
                                {t("Unlock greater flexibility in managing your product listings. With support for up to 2000 variants, you can now offer a wider range of options to your customers.")}
                            </Text>
                        </BlockStack>
                    </BlockStack>
                    <div style={{ visibility: "hidden", height: "28px" }}></div>
                </BlockStack>
            </Card>
        </Carousel>
    );
};

export default DI(HeroSection);